if (!customElements.get('localization-form')) {
  customElements.define( 'localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.localization__wrapperList'),
        collectionFullpageWrapperInner: document.querySelector('.collectionFullpage__wrapperInner'),
        headerBackground: document.querySelector('.header--background'),
      };

      this.boundToggleSelector = this.toggleSelector.bind(this);
      this.boundOnItemClick = this.onItemClick.bind(this);
      this.boundCloseSelector = this.closeSelector.bind(this);
    }

    connectedCallback() {
      this.elements.button.addEventListener('click', this.boundToggleSelector);
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.boundOnItemClick));

      if (this.classList.contains('header__countrySelectorForm')) {
        this.addEventListener('mouseleave', this.boundCloseSelector);
      }
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this.boundToggleSelector);
      this.querySelectorAll('a').forEach((item) => item.removeEventListener('click', this.boundOnItemClick));
      this.removeEventListener('mouseleave', this.boundCloseSelector);
    }

    onItemClick(event) {
      event.preventDefault();

      const form = this.querySelector('form');

      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    toggleSelector(event) {
      this.target = event.currentTarget;
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );

      this.handleHeaderCountrySelectorClasses('toggle');
    }

    closeSelector() {
      const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.elements.panel.setAttribute('hidden', '');
        this.elements.button.setAttribute('aria-expanded', 'false');

        this.handleHeaderCountrySelectorClasses('remove');
      }
    }

    handleHeaderCountrySelectorClasses(action) {
      if (this.target?.classList.contains('header__countrySelectorButton')) {
        const method = action === 'toggle' ? 'toggle' : 'remove';

        this.elements.collectionFullpageWrapperInner
          ?.classList[method]('collectionFullpage__wrapperInner--sticky-blocked');
        this.elements.headerBackground
          ?.classList[method]('header--background-long-blocked');
      }
    }
  });
}
